import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const importService = {
    importCatalog,
}

function importCatalog(payload) {
    return apiClient.post(`/import`, payload, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}
